module.exports = __webpack_public_path__ + "img/guanbi.61e4b9b0.png";